export default __webpack_public_path__ + "static/media/malay4.ec41f0fc.png";